export default {
  roleName: {
    label: 'Role Name',
    placeholder: 'Add role name',
    system: {
      name: 'roleName',
      altName: 'roleName',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'type',
    rules: {
      title: 'Type field',
      required: true,
    }
  },
};



// WEBPACK FOOTER //
// ./src/containers/RoleEdit/fields.js